function generateCorsAnywhereUrl(url) {
  return `https://cors-anywhere.herokuapp.com/${url}`
}

export default generateCorsAnywhereUrl



// WEBPACK FOOTER //
// ./src/utils/generateCorsAnywhereUrl.js